import { Stack } from 'common/ui/Layout';
import { ExamComment as ExamCommentType } from 'generated/graphql';
import { Colors } from 'styles/index';
import { toLocaleDateTimeString } from 'utils/date';
import Text from 'common/ui/Text';

export const ExamComment = ({
  examComment,
}: {
  examComment: Nullable<ExamCommentType>;
}): React.ReactElement | null => {
  if (examComment == null) {
    return null;
  }

  const { authorName, comment, createdAt } = examComment;
  const createdAtDate = new Date(createdAt);
  const dateTimeString = toLocaleDateTimeString(createdAtDate, { timeZoneName: 'short' });

  return (
    <Stack
      vertical
      css={`
        &:not(:last-child) {
          border-bottom: 1px solid ${Colors.gray6};
        }
      `}
    >
      <Stack
        vertical
        stretchX
        stretchY
        css={`
          padding: 12px;
        `}
      >
        <Stack alignX="between">
          <Text
            css={`
              color: ${Colors.gray8};
            `}
            variant="caption"
          >
            {authorName}
          </Text>
          <Text
            css={`
              color: ${Colors.gray8};
            `}
            variant="caption"
          >
            {dateTimeString}
          </Text>
        </Stack>
        <Stack
          style={{
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
        >
          {comment}
        </Stack>
      </Stack>
    </Stack>
  );
};
